
import { AssetTypeEntityDecorator } from './asset-type.decorator';
import { AssetType } from './asset-type.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class AssetTypeTypeInfoBase implements CrudTypeInfo<AssetType, number> {
  name = 'Asset Type';
  entityDecorator = new AssetTypeEntityDecorator();
  
  createAuthorities = ['WRITE_ASSET_TYPE'];
  editAuthorities = ['WRITE_ASSET_TYPE'];
  deleteAuthorities = ['WRITE_ASSET_TYPE'];
  viewAuthorities = ['READ_ASSET_TYPE'];
  
  searchRouteBase = ['/assettype/search'];
  createRouteBase = ['/assettype/create'];
  editRouteBase = ['/assettype/edit'];
  viewRouteBase = ['/assettype/view'];
  
  description(item: AssetType): string {
    return '' +  item.assetTypeId +  ' - ' +  item.name;
  }
}



